import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Elements from "./components/Elements";
import Categories from "./components/Categories";
import ShowFullItem from "./components/ShowFullItem";




class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      orders: [],
      currentItems: [],
      items: [
        {
          id: 1,
          title: 'Кресло оранжевое',
          img: 'chair1.jpg',
          desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          category: 'chairs',
          price: '59.90'
        },
        {
          id: 2,
          title: 'Софа серая',
          img: 'sofa1.jpg',
          desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          category: 'sofas',
          price: '159.90'
        },
        {
          id: 3,
          title: 'Стол красный',
          img: 'table1.jpeg',
          desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          category: 'tables',
          price: '345.90'
        },
        {
          id: 4,
          title: 'Кресло массив',
          img: 'chair2.jpg',
          desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          category: 'chairs',
          price: '99.10'
        },
        {
          id: 5,
          title: 'Софа черная',
          img: 'sofa2.jpg',
          desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          category: 'sofas',
          price: '119.90'
        },
        {
          id: 6,
          title: 'Стол черный',
          img: 'table2.jpg',
          desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          category: 'tables',
          price: '225.90'
        },
        {
          id: 7,
          title: 'Кресло серое',
          img: 'chair3.jpg',
          desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          category: 'chairs',
          price: '29.50'
        },
        {
          id: 8,
          title: 'Софа массив',
          img: 'sofa3.jpg',
          desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          category: 'sofas',
          price: '359.90'
        },
        {
          id: 9,
          title: 'Стол кухонный',
          img: 'table3.jpg',
          desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
          category: 'tables',
          price: '280.90'
        },
      ],
      showFullItem: false,
      fullItem: {}
    }
    this.state.currentItems = this.state.items
    this.addToOrder = this.addToOrder.bind(this)
    this.deleteOrder = this.deleteOrder.bind(this)
    this.chooseCategory = this.chooseCategory.bind(this)
    this.onShowItem = this.onShowItem.bind(this)
  }
  render() {
    return (
      <div className="wrapper" >
        <Header orders={this.state.orders} onDelete={this.deleteOrder} />
        <Categories chooseCategory={this.chooseCategory} />
        <Elements onShowItem={this.onShowItem} items={this.state.currentItems} onAdd={this.addToOrder} />

        {this.state.showFullItem && <ShowFullItem onShowItem={this.onShowItem} onAdd={this.addToOrder} item={this.state.fullItem} />}
        <Footer />
      </div>
    );
  }

  onShowItem(item) {
    this.setState({ fullItem: item })
    this.setState({ showFullItem: !this.state.showFullItem })
  }

  chooseCategory(category) {
    if (category === 'all') {
      this.setState({ currentItems: this.state.items })
      return
    }

    this.setState({
      currentItems: this.state.items.filter(el => el.category === category)
    })
  }

  deleteOrder(id) {
    this.setState({
      orders: this.state.orders.filter(el => el.id !== id)
    })
  }

  addToOrder(item) {
    let isInArray = false
    this.state.orders.forEach(el => {
      if (el.id === item.id)
        isInArray = true
    })
    if (!isInArray)
      this.setState({ orders: [...this.state.orders, item] })
  }
}

export default App;
